import { BucketInfo } from '../../../../../../data-access/gql-types/graphql';
import { getTimeParts } from '../../../../../../utils/helpers/time-convert';
import { HoursRangeFront } from '../../../channel-details/optimizer/configuration/types';
import { TariffName } from '../../../channel-details/optimizer/configuration/types/tariff-kind';
import { Segment, TariffCheckboxesVisibleParams } from '../types';

export const tariffCheckboxesVisible = ({ tariffName, isDouble }: TariffCheckboxesVisibleParams) => {
  return tariffName !== TariffName.Dynamic && tariffName !== TariffName.G13S && !isDouble;
};

export const heatmapColors = {
  0: '#00891C',
  1: '#65A521',
  2: '#93B224',
  3: '#FFD028',
  4: '#FFBA2E',
  5: '#FF943A',
  6: '#FF4D4D',
};

export const formatHour = (hour: number) => {
  if (hour === 24) return `${24}:00`;
  const formatted = hour % 24;
  const displayHour = formatted < 10 ? `0${formatted}:00` : `${formatted}:00`;
  // return displayHour === '24:00' ? '00:00' : displayHour;
  return displayHour;
};

export const calculateSegmentsByPricingTier = (ranges: HoursRangeFront[]) => {
  const segments: Segment[] = [];
  const tiersByHour: number[] = [];
  for (let h = 0; h < 24; h++) {
    tiersByHour[h] = getPricingTierForHour(h, ranges);
  }

  let startHour = 0;
  let currentTier = tiersByHour[0];

  for (let h = 1; h <= 24; h++) {
    const hour = h % 24;
    if (tiersByHour[hour] !== currentTier || h === 24) {
      segments.push({
        pricingTier: currentTier,
        value: (h - startHour) % 24 === 0 ? 24 : h - startHour,
        start: startHour,
        end: hour,
      });

      startHour = hour;
      currentTier = tiersByHour[hour];
    }
  }

  if (segments.length > 1) {
    const first = segments[0];
    const last = segments[segments.length - 1];
    if (first.pricingTier === last.pricingTier) {
      segments[0] = {
        pricingTier: first.pricingTier,
        value: first.value + last.value,
        start: last.start,
        end: first.end,
      };
      segments.pop();
    }
  }

  return segments;
};

export const groupRangesByTimeZoneKind = (ranges: HoursRangeFront[]) => {
  const groups = {};
  ranges.forEach((range) => {
    if (!groups[range.timeZoneKind]) {
      groups[range.timeZoneKind] = [];
    }
    groups[range.timeZoneKind].push(range);
  });
  return groups;
};

export const getPricingTierForHour = (hour: number, ranges: HoursRangeFront[]) => {
  for (const range of ranges) {
    const from = getTimeParts(range.from);
    const to = getTimeParts(range.to);

    if (range.from < range.to) {
      if (hour >= from.hours && hour < to.hours) return range.pricingTier;
    } else {
      if (hour >= from.hours || hour < to.hours) return range.pricingTier;
    }
  }

  const hasNeutralPricingTier = ranges.find((x) => x.pricingTier === 3);

  return hasNeutralPricingTier ? 2 : 3;
};

export const getHeatmapColor = (val: number, bucketInfos: BucketInfo[] | null) => {
  if (!bucketInfos) return null;

  const foundBucketIndex = bucketInfos.findIndex(
    (bucket) => val >= bucket.fromPriceInKWh && val <= bucket.toPriceInKWh,
  );

  if (foundBucketIndex !== -1) {
    return heatmapColors[foundBucketIndex] as string;
  }

  return null;
};
